import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate } from 'react-intl';

import { isValidDate } from '../../../../lib/DateUtils';
import { createBEM } from '../../../../lib/utils/css';

import './RowItemDate.scss';

const RowItemDate = React.memo(({ date, isRowSmall, useDarkTheme, useLightTheme }) => {
  if (!isValidDate(date)) {
    return null;
  }

  const classNames = createBEM('RowItemDate', {
    small: isRowSmall,
    dark: useDarkTheme,
    light: useLightTheme,
  });

  return (
    <div className={classNames}>
      <div className='RowItemDate__month'>
        <FormattedDate value={date} month='short' />
      </div>
      <div className='RowItemDate__day'>
        <FormattedDate value={date} day='numeric' />
      </div>
    </div>
  );
});

RowItemDate.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  isRowSmall: PropTypes.bool.isRequired,
  useDarkTheme: PropTypes.bool.isRequired,
  useLightTheme: PropTypes.bool.isRequired,
};

export default RowItemDate;
